import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { detailListPath } from "@shared/navigation/tabs/detailListPath";

/**
 * Leaves a detail for its list (CTX-1281). Called by the partner/customer selector when
 * the user picks someone else: a detail is one customer's resource, and under another
 * customer it reads "not found" or, worse, keeps showing what is no longer theirs.
 *
 * Only the selector calls it, never a listener on the tenant itself: activating a view
 * (13D) also restores a tenant, and that view must stay on its page. Replaces the
 * history entry, so Back does not return to a detail of the previous customer.
 */
export function useLeaveDetail(): () => void {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  return useCallback(() => {
    const list = detailListPath(pathname, search);
    if (list) navigate(list, { replace: true });
  }, [navigate, pathname, search]);
}
